import React from "react"
import Showcase from "../components/Showcase"
import {
  Window,
  Grid,
  Col,
  View,
  Accordion,
  AccordionItem,
  Text,
} from "react-ame-components"

export class AccordionExample extends React.Component {
  render() {
    return (
      <Showcase
        title="Componente Accordion"
        description="Este componente serve para exibir informações em tópicos.">
        <Accordion>
          <AccordionItem title="Seguro Celular">
            <View
              paddingBottom="nano"
              paddingTop="nano">
              <Text fontWeight="bold">Quanto Custa?</Text>
            </View>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <View
              paddingBottom="nano"
              paddingTop="nano">
              <Text fontWeight="bold">Qual o tempo minimo de carencia?</Text>
            </View>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <View
              paddingBottom="nano"
              paddingTop="nano">
              <Text fontWeight="bold">Qual o tipo de proteção?</Text>
            </View>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
          </AccordionItem>
          <AccordionItem title="Seguro Casa">
            <View
              paddingBottom="nano"
              paddingTop="nano">
              <Text fontWeight="bold">Quanto Custa?</Text>
            </View>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <View
              paddingBottom="nano"
              paddingTop="nano">
              <Text fontWeight="bold">Qual o tempo minimo de carencia?</Text>
            </View>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <View
              paddingBottom="nano"
              paddingTop="nano">
              <Text fontWeight="bold">Qual o tipo de proteção?</Text>
            </View>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
          </AccordionItem>
          <AccordionItem title="Seguro Pet">
            <View
              paddingBottom="nano"
              paddingTop="nano">
              <Text fontWeight="bold">Quanto Custa?</Text>
            </View>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <View
              paddingBottom="nano"
              paddingTop="nano">
              <Text fontWeight="bold">Qual o tempo minimo de carencia?</Text>
            </View>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <View
              paddingBottom="nano"
              paddingTop="nano">
              <Text fontWeight="bold">Qual o tipo de proteção?</Text>
            </View>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
            <Text>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Reprehenderit doloribus quis magni possimus! Architecto rem
              veritatis est quaerat, ab inventore quidem eaque maxime? Eius
              dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Ipsam ex itaque sint aliquid quae
              vel ea ratione dolores quia blanditiis dolor nihil, in hic
              praesentium temporibus? Iste porro distinctio nisi! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Fugit sed atque ab ex
              qui ea ullam nisi nemo magni ut maiores mollitia libero corrupti
              cupiditate unde dignissimos, est soluta nesciunt! Lorem ipsum
              dolor sit amet consectetur adipisicing elit. Quo, voluptate et
              dignissimos adipisci sit voluptas vero repellendus accusantium,
              nostrum voluptatum maiores totam quidem ipsum ipsam eius ad
              deserunt facere non!
            </Text>
          </AccordionItem>
          <AccordionItem title="Novos Seguros">
            <Accordion>
              <AccordionItem title="Seguro Celular">
                <View
                  paddingBottom="nano"
                  paddingTop="nano">
                  <Text fontWeight="bold">Quanto Custa?</Text>
                </View>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <View
                  paddingBottom="nano"
                  paddingTop="nano">
                  <Text fontWeight="bold">
                    Qual o tempo minimo de carencia?
                  </Text>
                </View>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <View
                  paddingBottom="nano"
                  paddingTop="nano">
                  <Text fontWeight="bold">Qual o tipo de proteção?</Text>
                </View>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
              </AccordionItem>
              <AccordionItem title="Seguro Casa">
                <View
                  paddingBottom="nano"
                  paddingTop="nano">
                  <Text fontWeight="bold">Quanto Custa?</Text>
                </View>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <View
                  paddingBottom="nano"
                  paddingTop="nano">
                  <Text fontWeight="bold">
                    Qual o tempo minimo de carencia?
                  </Text>
                </View>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <View
                  paddingBottom="nano"
                  paddingTop="nano">
                  <Text fontWeight="bold">Qual o tipo de proteção?</Text>
                </View>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
              </AccordionItem>
              <AccordionItem title="Seguro Pet">
                <View
                  paddingBottom="nano"
                  paddingTop="nano">
                  <Text fontWeight="bold">Quanto Custa?</Text>
                </View>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <View
                  paddingBottom="nano"
                  paddingTop="nano">
                  <Text fontWeight="bold">
                    Qual o tempo minimo de carencia?
                  </Text>
                </View>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <View
                  paddingBottom="nano"
                  paddingTop="nano">
                  <Text fontWeight="bold">Qual o tipo de proteção?</Text>
                </View>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
                <Text>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Reprehenderit doloribus quis magni possimus! Architecto rem
                  veritatis est quaerat, ab inventore quidem eaque maxime? Eius
                  dolore quod totam vero mollitia saepe! Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit. Ipsam ex itaque sint
                  aliquid quae vel ea ratione dolores quia blanditiis dolor
                  nihil, in hic praesentium temporibus? Iste porro distinctio
                  nisi! Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugit sed atque ab ex qui ea ullam nisi nemo magni ut maiores
                  mollitia libero corrupti cupiditate unde dignissimos, est
                  soluta nesciunt! Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, voluptate et dignissimos adipisci sit
                  voluptas vero repellendus accusantium, nostrum voluptatum
                  maiores totam quidem ipsum ipsam eius ad deserunt facere non!
                </Text>
              </AccordionItem>
            </Accordion>
          </AccordionItem>
        </Accordion>
      </Showcase>
    )
  }
}
